export const BASE_URL = 'https://cms.municipalidadcartagena.cl';
export const HOST_URL = 'https://muni.2reflex.cl';
